import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

export default function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center" data-testid="protected-loading">
        <div className="h-12 w-12 border-4 border-[#1E2A78] border-t-transparent rounded-full animate-spin"></div>
      </div>
    );
  }
  if (!user || user === false) return <Navigate to="/admin/login" replace />;
  return children;
}
